import { getEnvironment } from '@jira/platform__get-tenant-context/src/index.tsx';
import killswitch from '@jira/platform__utils-feature-gates-killswitch/src/index.tsx';
import { getLocationSearch } from './getLocationSearch.tsx';

const isNonProductionEnvironment = (): boolean => {
	const environment = getEnvironment();
	return environment === 'staging' || environment === 'dev' || environment === 'local';
};

export const isStableUIEnabledForTests = (): boolean => {
	if (!isNonProductionEnvironment()) {
		return false;
	}

	if (killswitch('jira_stable_ui_for_tests')) {
		return false;
	}

	return getLocationSearch().includes('stableUI=1');
};
